export const admissions = {
  title: "Processo de Admissão",
  subtitle: "Acompanhamo-lo em cada passo do caminho para fazer parte da nossa comunidade educativa",
  process: {
    title: "Passos para aderir à Gándara",
    steps: [
      {
        title: "Contacto inicial",
        description: "Entre em contacto connosco por telefone, email ou através do nosso site para expressar o seu interesse."
      },
      {
        title: "Visita guiada",
        description: "Reserve uma visita para conhecer as nossas instalações, metodologia e equipa educativa. Poderá esclarecer todas as suas dúvidas."
      },
      {
        title: "Pedido de admissão",
        description: "Complete o formulário de inscrição com as informações do seu filho/a e família."
      },
      {
        title: "Entrevista familiar",
        description: "Teremos uma conversa com a família para conhecê-los melhor e garantir que partilhamos valores e expectativas."
      },
      {
        title: "Confirmação e matrícula",
        description: "Se houver vagas disponíveis e ambas as partes concordarem, procederemos com a formalização da matrícula."
      }
    ]
  },
  requirements: {
    title: "Documentação necessária",
    items: [
      "Formulário de inscrição completo",
      "Fotocópia do BI/Passaporte do aluno/a",
      "Fotocópia do BI dos pais/tutores",
      "Certidão de nascimento",
      "Certificado médico atualizado",
      "Fotografia recente tamanho passe",
      "Comprovativo do pagamento da matrícula"
    ]
  },
  visit: {
    title: "Reserve a sua visita",
    description: "O primeiro passo é conhecer-nos. Agende uma visita para descobrir a Gándara.",
    button: "Agendar visita"
  },
  contact: {
    title: "Tem dúvidas?",
    description: "Estamos aqui para ajudar. Contacte-nos e esclareceremos todas as suas questões.",
    button: "Contactar"
  }
};
